export enum PaymentPlanServiceEndpoitns {
    PostCreatePaymentPlan = '/v1/paymentplan/create',
}
